// Generaciones 2010-2016: casi siempre el plantel ocupa 3 posiciones (7 a 9) en la matrícula ("021"), pero hay
// matrículas de esas generaciones con 2 posiciones, como las demás (ej. 15414082110242 es del plantel 21, no del
// 211). Por eso solo se toman las 3 si forman un plantel que existe (1 a 31). Medido contra las inscripciones del
// Sistema Escolar (27/10/2026): acierta en 46,985 de 47,292 matrículas de esas generaciones (antes 45,880).
// Resto de generaciones: 2 posiciones (7 y 8).
const ULTIMO_PLANTEL = 31;
export const plantelDeMatricula = (matricula) => {
  const matriculaStr = String(matricula);
  const anio = parseInt(matriculaStr.substring(0, 2), 10);

  if (anio >= 10 && anio <= 16) {
    const tres = parseInt(matriculaStr.substring(7, 10), 10);
    if (tres >= 1 && tres <= ULTIMO_PLANTEL) return String(tres).padStart(2, "0");
  }
  return matriculaStr.substring(7, 9);
};

// El id de plantel en la base de datos va corrido en 2 respecto al plantel oficial
// (id 03 en BD = plantel 01 Tesistán).
export const idBDDesdePlantel = (plantelOficial) =>
  (parseInt(plantelOficial, 10) + 2).toString();

export const plantelOficialDesdeIdBD = (idBD) =>
  String(Number(idBD) - 2).padStart(2, "0");
